import React from 'react';
import PricingWidget from './components/PricingWidget';

function App() {
  return (
    <div className="min-h-screen bg-[#E9F1F0] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Workshop Prijscalculator
          </h1>
          <p className="mt-4 text-xl text-gray-500">
            Transparante prijzen afgestemd op uw team en behoeften.
          </p>
        </div>
        <PricingWidget />
      </div>
    </div>
  );
}

export default App;